import {createContext} from "react";

const ConfigContext = createContext();

export default ConfigContext;

export const ConfigProvider = ({ children }) => {

    const contextData = {
        baseUrl: 'https://apartmanback.trilogic.hu/',
        // baseUrl: 'http://127.0.0.1:8000/',
        apartmentId: 1
    }

    return <ConfigContext.Provider value={contextData}>{children}</ConfigContext.Provider>
}